import React, { Component } from 'react';
import Title from './title';
import { Menu } from 'semantic-ui-react';
import Menus from './menu';

class Home extends Component {

  render() {
    return (
      <div>
        <Title openDrawer={this.props.openDrawer} menus={this.props.menus} />
      </div>
    );
  }
}

export default Home;
